import React from 'react';

function XmarkIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={"30px"} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#FFFFFF" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
    )
}

export default XmarkIcon;